module.exports = __webpack_public_path__ + "static/media/profumeriacosmesi.4a310880.png";